module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-block-inner step-four"
  }, [_c('span', {
    staticClass: "product-block-span step-four-top-margin"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  }), _vm._v(" "), _c('DemoButton', {
    attrs: {
      "buttonMessage": 'Software, Amazon value props'
    }
  })], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "product-block-span step-four-images"
  }, [_c('img', {
    staticClass: "optimize-image",
    attrs: {
      "src": require("../../../../assets/winter-2019/step-amazon.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3416d310"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/site/MikMakAttach/components/StepAmazonValueProps.vue
// module id = 468
// module chunks = 0